export default "__VITE_ASSET__6oZOhT_u__"